import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { AsnItemsInfo } from './asn-items-info.model';
export class AsnDto {
  @ApiProperty()
  @IsNotEmpty({message:"GRN Id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  asnId?: number;

  @ApiProperty()
  @IsNotEmpty({message:"asn Date should not be empty"})
  @IsAlphanumeric()
  asnDate: Date;

  @ApiProperty()
  @IsAlphanumeric()
  asnNumber: string;

  @ApiProperty()
  @IsAlphanumeric()
  eWayBillNo: string;

  @ApiProperty()
  @IsAlphanumeric()
  dcNumber: string;

  @ApiProperty()
  @IsNotEmpty({message:"asn Numbere should not be empty"})
  @IsAlphanumeric()
  shipmentNumber?: string;

  @ApiProperty()
  @IsNotEmpty({message:"vendor should not be empty"})
  @IsAlphanumeric()
  vendorId: number;

 

  @ApiProperty()
  @IsNotEmpty({message:"Unit Id Id should not be empty"})
  @IsAlphanumeric()
  unitId: number;

  
  @ApiProperty()
  @IsAlphanumeric()
  totalQuantity: number;

  @ApiProperty()
  @IsAlphanumeric()
  asnQuantity: number;
  

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  remarks: string;
  

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser ?: string;

  poNum?: string;
  
  @ApiProperty({ type: [AsnItemsInfo]})
  asnItemsInfo: AsnItemsInfo[];

  @ApiProperty()
  fileName?:string;
  
  @ApiProperty()
  filePath?:string;

}

